import dynamic from "next/dynamic"
import { ELanguage } from "@microfrontends/react-components"
import StaticPageProvider from "@/app-context"
import { IUser } from "@/services/authService"
import { pageMap } from "@/static-pages/pageMapping"
import { getServerSideProps } from "@/ssr"

const Layout = dynamic(() => import('@/components/Layout'))

interface TPageProps {
    user: IUser
    langCode: ELanguage
    slug: string
}

const StaticPage = (props: TPageProps) => {
    const { user, slug, langCode } = props
    
    const PageComponent = pageMap[slug as string]

    return (
        <StaticPageProvider langCode={langCode} user={user}>
            <Layout>
                <PageComponent />
            </Layout>
        </StaticPageProvider>
    )
}

export { getServerSideProps }
export default StaticPage
